// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-sidebar-minicollectionlist--wrapper","create":"app-components-sidebar-minicollectionlist--create"};